import { MenuItem } from '@common/generic/models/MenuItem';
import { constants } from '@common/constants';

export const MENU_ITEMS: MenuItem[] = [
  {
    text: 'Participants',
    links: ['participants'],
    roles: [
      // tslint:disable-next-line:comment-format
      //constants.roles.SchemeOwner,
      constants.roles.SchemeAdmin,
      constants.roles.ArPartyAdmin,
      constants.roles.BcPartyAdmin,
      constants.roles.CttPartyAdmin,
      // tslint:disable-next-line:comment-format
      constants.roles.PartyAdmin,
      // tslint:disable-next-line:comment-format
      //constants.roles.SatelliteAdmin,
      constants.roles.User ],
    class: 'fa fa-users',
    subMenu : [],
  },
  {
    text: 'My Participants',
    links: ['participants'],
    roles: [
      constants.roles.SchemeOwner,
      constants.roles.SatelliteAdmin,
    ],
    class: 'fa fa-users',
    subMenu : [],
  },
  {
    text: 'All Participants',
    links: ['participants', 'all'],
    roles: [
      constants.roles.SchemeOwner,
      constants.roles.SatelliteAdmin,
    ],
    class: 'fa fa-users',
    subMenu : [],
  },
  {
    text: 'Users',
    links: ['users'],
    roles: [
      constants.roles.SchemeOwner,
      constants.roles.SchemeAdmin,
      constants.roles.PartyAdmin,
      constants.roles.SatelliteAdmin,
      constants.roles.User
    ],
    class: 'fa fa-user-plus',
    subMenu : [],
  },
  {
    text: 'Dataspace',
    links: ['dataspace'],
    class: 'fa fa-users',
    roles: [
      constants.roles.SchemeOwner,
      constants.roles.SchemeAdmin,
    ],
    subMenu : [],
  },
  {
    text: 'TrustedList',
    links: ['trusted'],
    class: 'fa fa-list-ul',
    roles: [
      constants.roles.SchemeOwner,
      constants.roles.SchemeAdmin,
    ],
    subMenu : [],
  },
  {
    text: 'Transfer',
    links: ['transfer'],
    class: 'fa fa-exchange',
    roles: [
      constants.roles.SchemeOwner,
      constants.roles.SchemeAdmin,
      // tslint:disable-next-line:comment-format
      //constants.roles.PartyAdmin,
      constants.roles.SatelliteAdmin,
      // tslint:disable-next-line:comment-format
      //constants.roles.User
    ],
    subMenu : [],
  },
  {
    text: 'Revoke',
    links: ['revoke'],
    roles: [
      constants.roles.SchemeOwner,
      constants.roles.SchemeAdmin
    ],
    class: 'fa fa-users',
    subMenu : [],
  },
  {
    text: 'Scheduler',
    links: ['scheduler'],
    roles: [
      constants.roles.SchemeOwner,
      constants.roles.SatelliteAdmin,
    ],
    class: 'fa fa-calendar',
    subMenu : [],
  },
  {
    text: 'Network Health Check',
    links: ['networkHealthCheck'],
    roles: [
      constants.roles.SchemeOwner,
      constants.roles.SatelliteAdmin,
    ],
    class: 'fa fa-heartbeat',
    subMenu : [],
  },
  {
    text: 'Network Admin',
    links: ['network-admin'],
    roles: [
      constants.roles.SchemeOwner
    ],
    class: 'fa fa-sitemap',
    subMenu : [],
  },
  {
    text: 'Reports',
    links: [],
    roles: [
      constants.roles.SchemeOwner,
      constants.roles.SchemeAdmin
    ],
    subMenu: [
      {
        text: 'Group By Satellite',
        links: ['reports', 'groupbysatellite'],
        class: 'fa fa-dot-circle-o'
      },
      {
        text: 'Group By AR',
        links: ['reports', 'groupbyar'],
        class: 'fa fa-circle'
      },
      {
        text: 'Group By Roles',
        links: ['reports', 'groupbyroles'],
        class: 'fa fa-user'
      },
      {
          text: 'Group By Region',
          links: ['reports', 'region'],
          class: 'fa fa-flag'
      },
      {
          text: 'Group By Sector',
          links: ['reports', 'sector'],
          class: 'fa fa-industry'
      },
      {
          text: 'Group By Dataspace',
          links: ['reports', 'groupByDataspaces'],
          class: 'fa fa-circle-o'
      },
      {
          text: 'Satellites Dataspace',
          links: ['reports', 'satellites'],
          class: 'fa fa-circle-thin'
      }
    ],
    // roles: [
    //   constants.roles.SchemeOwner,
    //   constants.roles.SchemeAdmin
    //   ],
    class: 'fa fa-file'
  },
  // {
  //   text: 'Group By AR',
  //   links: ['reports', 'groupbyar'],
  //   // roles: [
  //   //   constants.roles.SchemeOwner,
  //   //   constants.roles.SchemeAdmin
  //   // ],
  //   class: 'fa fa-file',
  //   subMenu : [],
  // },
  // {
  //   text: 'Group By Roles',
  //   links: ['reports', 'groupbyroles'],
  //   // roles: [
  //   //   constants.roles.SchemeOwner,
  //   //   constants.roles.SchemeAdmin
  //   // ],
  //   class: 'fa fa-file'
  // },
  // {
  //   text: 'Group By Region',
  //   links: ['reports', 'region'],
  //   // roles: [
  //   //   constants.roles.SchemeOwner,
  //   //   constants.roles.SchemeAdmin
  //   // ],
  //   class: 'fa fa-file'
  // },
  // {
  //   text: 'Group By Sector',
  //   links: ['reports', 'sector'],
  //   // roles: [
  //   //   constants.roles.SchemeOwner,
  //   //   constants.roles.SchemeAdmin
  //   // ],
  //   class: 'fa fa-file'
  // },
  // {
  //   text: 'Group By Dataspace',
  //   links: ['reports', 'groupByDataspaces'],
  //   // roles: [
  //   //   constants.roles.SchemeOwner,
  //   //   constants.roles.SchemeAdmin
  //   // ],
  //   class: 'fa fa-file'
  // },
  // {
  //   text: 'Satellites Dataspace',
  //   links: ['reports', 'satellites'],
  //   // roles: [
  //   //   constants.roles.SchemeOwner,
  //   //   constants.roles.SchemeAdmin
  //   // ],
  //   class: 'fa fa-file'
  // }

];
